"use client";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";

const HeadComp = ({ Bg_Image, heading }) => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box
      backgroundImage={`url(${Bg_Image.src})`}
      backgroundPosition={"center"}
      backgroundRepeat={"no-repeat"}
      backgroundSize="cover"
      h="400px"
      borderRadius={"18px"}
      py={{ base: "4rem", md: "10rem" }}
      px={{ base: "2rem", md: "6rem" }}
    >
      <Flex
        direction="column"
        gap="4rem"
        justifyContent={{ base: "center", md: "flex-start" }}
        color="white"
        height="100%"
      >
        <Heading variant={HeadingVariant} width={{ base: "100%", md: "70%" }}>
          🚀 {heading}
        </Heading>
      </Flex>
    </Box>
  );
};

export default HeadComp;
